import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=3a928990&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=3a928990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a928990",
  null
  
)

export default component.exports